export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "I was terrified of the 'AI Hallucination' traps everyone talks about. I didn't want a court shredding my motions. After 3 days with the SIGMA SMART™ prompts, I drafted a complex Motion to Dismiss in 15 minutes. Now, I finish my work and get home for dinner every single day.",
    name: 'Robert J. M.',
    location: 'Miami, FL · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c671b38a-19e1-4b5e-ad8a-7136d452eff8.jpg',
  },
  {
    quote:
      'I was drowning in discovery files, frustrated because paperwork was keeping me away from actual lawyering. This system actually works. The logic in the Contract Intelligence pack is unmatched. My drafts are now the gold standard in my firm.',
    name: 'Sarah L.',
    location: 'London, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/90687afb-6951-4cd2-8972-de069b8659d8.jpg',
  },
  {
    quote:
      "I was worried AI would sound too 'robotic' for a high-stakes demand letter. SIGMA SMART™ proved me wrong. The prompts are vetted, professional, and persuasive. I felt confident using them from DAY ONE.",
    name: 'David P.',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e0f7d171-95bf-4fc6-880b-cdc0c670c708.jpg',
  },
];
